import React, { useEffect, useState } from "react";
//hooks
import useHTTP from "@/components/hooks/useHTTP";

//interfaces
import { IAcknowledgementGroupProps } from "@/interfaces/acknowledgements";

//utilities
import { Truncate } from "@/helpers/Text";
import { BuildPath } from "@/helpers/Paths";
import { getContentIdFromContentUrl } from "../search/utility";

//components
import ModalWrapper from "@/components/modals/ModalWrapper";
import AcknowledgementGroupModal from "@/components/modals/content/AcknowledgementGroupModal";
import Toast, { IToastVariables, ToastMessageType } from  '@/components/elements/global/ToastNotification';



const AcknowledgementGroup: React.FC<IAcknowledgementGroupProps> = ({ acknowledgementsGroup, isOrgAdmin, appId, getAcknowledgementGroup}) => {
    const { post, put } = useHTTP();

    const { groupName: acknowledgementsGroupName } = acknowledgementsGroup;
    const contentId = getContentIdFromContentUrl(window.location.href);

    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [groupName, setGroupName] = useState<string>(acknowledgementsGroupName);

    //modal error message handling
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false);

    //success toast message handling
    const [toastVariables, setToastVariables] = useState<IToastVariables>({message: undefined, messageType: undefined});
    const [showToast, setShowToast] = useState<boolean>();


    const handleModalOpen = () => {
        setGroupName(acknowledgementsGroupName);
        setErrorMessage("");
        setShowErrorMessage(false); 
        setModalOpen(true);
    };

    function truncateGroupName() {
        if (acknowledgementsGroupName) {
            return Truncate(acknowledgementsGroupName, 40)
        }
        return "";
    }

    function handleApiError(error: any) {
        if (error.response) {
            if (error.response.status === 400 && error.response.data === "Acknowledgements group already exists") {
                setErrorMessage("Group name already exists");
                setShowErrorMessage(true);
            } else if (error.response.status === 500 ){
                console.error(error.message);
                setErrorMessage("Network error. Please try again later.");
                setShowErrorMessage(true);
            } else {
                console.error(error.message);
            }
        }
    }
  
    function createGroup(requestBody: any) {
        post(`content/${appId}/content/${contentId}/createackgroup`, requestBody)
          .then(({}) => {
            setToastVariables({
                messageType: ToastMessageType.SUCCESS,
                message: `Acknowledgement Group -"${groupName}" successfully created`,
              });
            setGroupName(acknowledgementsGroup.groupName);
            setModalOpen(false);
          })
          .catch((error) => {
            handleApiError(error);
          })
          .finally(() => {
            getAcknowledgementGroup();
          })
    }

    function updateGroup(requestBody: any) {
        put(`content/${appId}/content/${contentId}/updateackgroupname`, requestBody)
        .then(({}) => {
            setToastVariables({
              messageType: ToastMessageType.SUCCESS,
              message: `Acknowledgement Group renamed to "${groupName}"`,
            });
            setShowToast(true);
            setGroupName(acknowledgementsGroup.groupName);
            setModalOpen(false);
        })
        .catch((error) => {
            handleApiError(error);
        })
        .finally(() => {
            getAcknowledgementGroup();
        });
    }

    useEffect(() => {
        if ((groupName) && (groupName !== acknowledgementsGroup.groupName)) {
            const requestObj = { groupName : groupName };

            if (!acknowledgementsGroup.groupName) {
                createGroup(requestObj);
            } else {
                updateGroup(requestObj);
            }
        }
    }, [groupName]);



    return (
        <>
        {showToast &&
            <Toast 
                show={showToast} 
                closeToast={() => setShowToast(false)} 
                messageType={toastVariables?.messageType ?? undefined}
            > 
                    {toastVariables?.message ?? ""}
            </Toast>
        }


        <div className="acknowledgement-group-container">
            <div className="acknowledgements-group-details">

                <img className={`user-group-image`} src={`${BuildPath()}/images/user-group.svg`} alt="users" />

                {acknowledgementsGroupName
                
                ? (
                    <>        
                        {isOrgAdmin 
                        ? (
                            <>
                            <button id="acknowledgements-group-link"  className="acknowledgements-group-button" onClick={handleModalOpen} title={acknowledgementsGroupName}>
                                {truncateGroupName()}
                            </button>

                            <button className="edit-group-button link-style-button" title="Edit Group Name" onClick={handleModalOpen}>
                                <img alt="" className="edit-group-image" src={`${BuildPath()}/images/edit.svg`} />
                            </button>
                            </>
                        ) : (
                            <span id="acknowledgements-group-name" className="acknowledgements-group-name">
                                {truncateGroupName()}
                            </span>
                        )}
                    </>
                ) : (

                    <button id="create-group-button" className="create-group link-style-button" onClick={handleModalOpen}>
                        Create Group
                    </button>

                )}
            </div>

            {modalOpen &&
                <ModalWrapper isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} className={`acknowledgement-group-modal-wrapper ${acknowledgementsGroupName ? `edit-modal-wrapper` : `create-modal-wrapper`}`}>
                    <AcknowledgementGroupModal 
                        isCreateGroupModal={!acknowledgementsGroupName} 
                        groupName={acknowledgementsGroupName} 
                        setGroupName={setGroupName}
                        modalClassName={acknowledgementsGroupName ? "edit-group-modal" : "create-group-modal"} 
                        onCancelClick={() => setModalOpen(false)}
                        errorMessage={errorMessage}
                        showErrorMessage={showErrorMessage}
                        setShowErrorMessage={setShowErrorMessage}
                    />
                </ModalWrapper>
            }
        </div>
        </>
    );
};

export default AcknowledgementGroup;
